import { defineContent } from './defineContent.js';
import data from './footer.json';
import { footerSchema } from './footer.schema.js';

export const footer = defineContent(footerSchema, data);
